<template>
	<Select :disabled="disabled" :value="value" @on-change="mychange" filterable placeholder="选择时间" >
		<Option  value="00:00">00:00</Option>
		<Option  value="00:30">00:30</Option>
		<Option  value="01:00">01:00</Option>
		<Option  value="01:30">01:30</Option>
		<Option  value="02:00">02:00</Option>
		<Option  value="02:30">02:30</Option>
		<Option  value="03:00">03:00</Option>
		<Option  value="03:30">03:30</Option>
		<Option  value="04:00">04:00</Option>
		<Option  value="04:30">04:30</Option>
		<Option  value="05:00">05:00</Option>
		<Option  value="05:30">05:30</Option>
		<Option  value="06:00">06:00</Option>
		<Option  value="06:30">06:30</Option>
		<Option  value="07:00">07:00</Option>
		<Option  value="07:30">07:30</Option>
		<Option  value="08:00">08:00</Option>
		<Option  value="08:30">08:30</Option>
		<Option  value="09:00">09:00</Option>
		<Option  value="09:30">09:30</Option>
		<Option  value="10:00">10:00</Option>
		<Option  value="10:30">10:30</Option>
		<Option  value="11:00">11:00</Option>
		<Option  value="11:30">11:30</Option>
		<Option  value="12:00">12:00</Option>
		<Option  value="12:30">12:30</Option>
		<Option  value="13:00">13:00</Option>
		<Option  value="13:30">13:30</Option>
		<Option  value="14:00">14:00</Option>
		<Option  value="14:30">14:30</Option>
		<Option  value="15:00">15:00</Option>
		<Option  value="15:30">15:30</Option>
		<Option  value="16:00">16:00</Option>
		<Option  value="16:30">16:30</Option>
		<Option  value="17:00">17:00</Option>
		<Option  value="17:30">17:30</Option>
		<Option  value="18:00">18:00</Option>
		<Option  value="18:30">18:30</Option>
		<Option  value="19:00">19:00</Option>
		<Option  value="19:30">19:30</Option>
		<Option  value="20:00">20:00</Option>
		<Option  value="20:30">20:30</Option>
		<Option  value="21:00">21:00</Option>
		<Option  value="21:30">21:30</Option>
		<Option  value="22:00">22:00</Option>
		<Option  value="22:30">22:30</Option>
		<Option  value="23:00">23:00</Option>
		<Option  value="23:30">23:30</Option>
		<Option  value="24:00">24:00</Option>
	
	</Select>
</template>

<script>
	export default {
		model: {
		    prop: 'value',
		    event: 'change'
		  },
		props: [
			'value',
			'disabled'
		],
		data() {
			return {
				//分页属性
			selectValue :this.value
			};
		},
		methods: {

			mychange: function(a) {
				this.$emit('change', a)
				
			},
		}
	}
</script>

<style>

</style>
